import { AxiosInstance } from 'axios';
import { API_URL } from '../constants';
import axios from './axios';

const partnerAxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

let client: AxiosInstance | null = null;

const getInstance = (): AxiosInstance => {
  if (client === null) {
    client = partnerAxiosInstance;
  }
  return client;
};

export default getInstance();
